import {CurrencyType} from "./currency";

export enum Locale {
  EN_001 = "en-001",
  EN_US = "en-US",
  EN_SG = "en-SG",
  EN_IN = "en-IN",
}

export type LocaleMetadata = {
  code: string,
  text: string,
  image?: string,
  currencyType: CurrencyType,
  phoneNumberAllowedCountryCodes?: string[],
}

export const LOCALE_METADATA = new Map<Locale, LocaleMetadata>([
  [Locale.EN_001, {
    code: "001",
    text: "Global",
    image: "/images/locale-001.png",
    currencyType: CurrencyType.US_DOLLAR,
  }],
  [Locale.EN_US, {
    code: "US",
    text: "United States",
    currencyType: CurrencyType.US_DOLLAR,
    phoneNumberAllowedCountryCodes: ["US", "CA"],
  }],
  [Locale.EN_SG, {
    code: "SG",
    text: "Singapore",
    currencyType: CurrencyType.SG_DOLLAR,
    phoneNumberAllowedCountryCodes: ["SG"],
  }],
  [Locale.EN_IN, {
    code: "IN",
    text: "India",
    currencyType: CurrencyType.IN_RUPEE,
    phoneNumberAllowedCountryCodes: ["IN"],
  }],
]);
